import settings from '@/settings';

export interface ZipcodeStateData {
  state: string;
  stateName: string;
  zipcode: string;
  region?: string;
  isDefault?: boolean;
}

export const CUSTOMER_STATE_ZIPCODE = `customer-state-zipcode-${settings.store}`;

export const DEFAULT_ZIPCODE_STATE: Record<string, ZipcodeStateData> = {
  'reebelo-au': {
    zipcode: '2000',
    state: 'NSW',
    stateName: 'New South Wales',
    region: 'Sydney Metro',
    isDefault: true,
  },
  'reebelo-nz': {
    zipcode: '1010',
    state: 'AUK',
    stateName: 'Auckland',
    isDefault: true,
  },
  'reebelo-ca': {
    zipcode: 'M4W 2G8',
    state: 'ON',
    stateName: 'Ontario',
    isDefault: true,
  },
};

export const getDefaultZipcodeState = (): ZipcodeStateData | null =>
  DEFAULT_ZIPCODE_STATE[settings.store] ?? null;

export const isSameDestination = (
  a: Pick<ZipcodeStateData, 'state' | 'region'> | null | undefined,
  b: Pick<ZipcodeStateData, 'state' | 'region'> | null | undefined,
): boolean =>
  (a?.state ?? null) === (b?.state ?? null) &&
  (a?.region ?? null) === (b?.region ?? null);

const isFilled = (value: unknown): value is string =>
  typeof value === 'string' && value.trim() !== '';

export const parseZipcodeState = (
  raw?: string | null,
): ZipcodeStateData | null => {
  if (!raw) {
    return null;
  }

  try {
    const parsed: unknown = JSON.parse(raw);

    if (typeof parsed !== 'object' || parsed === null) {
      return null;
    }

    const stored = parsed as Record<string, unknown>;

    if (
      !isFilled(stored.state) ||
      !isFilled(stored.stateName) ||
      !isFilled(stored.zipcode)
    ) {
      return null;
    }

    // Optional, but read the same way as the rest when it is there.
    if (stored.region !== undefined && !isFilled(stored.region)) {
      return null;
    }

    return {
      state: stored.state,
      stateName: stored.stateName,
      zipcode: stored.zipcode,
      ...(isFilled(stored.region) ? { region: stored.region } : {}),
      ...(stored.isDefault === true ? { isDefault: true } : {}),
    };
  } catch {
    return null;
  }
};
